import React, { useCallback, useState } from "react";
import { Button, Modal } from "antd";
import Form from "../forms/CreateDeclarant";
import { MANUAL_BUTTON } from "../../constants/translates";
import { Option } from "../common/forms/Interfaces";
import Authorize from "../Authorize";
import { MANUAL_CREATION } from "../../constants/authorize";

interface Props {
  clients: Option[];
  noClient?: Option;
  departments: Option[];
}
const CreateDeclarant: React.FC<Props> = ({
  clients,
  noClient,
  departments,
}) => {
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);

  const onToggleModalHandler = useCallback(() => {
    setModalVisibility(!modalVisibility);
  }, [modalVisibility]);

  const onCancelHandler = useCallback(() => {
    setModalVisibility(false);
  }, []);

  return (
    <Authorize permission={MANUAL_CREATION}>
      <>
        <Button type="primary" onClick={onToggleModalHandler} size="small">
          {MANUAL_BUTTON}
        </Button>
        <Modal
          visible={modalVisibility}
          onCancel={onCancelHandler}
          footer={null}
        >
          <Form
            onFinish={onCancelHandler}
            clients={clients}
            noClient={noClient}
            departments={departments}
          />
        </Modal>
      </>
    </Authorize>
  );
};

export default CreateDeclarant;
